import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { getEmailAndNamesGremlinSP } from '../../../Organisms/Common/MeetingSlotCard/O_MeetingSlotCard.helper'
import { epochToDateFormatHelper } from '../../../../../Utils/Helpers/dateUtils'
import { Typography } from '@material-ui/core'
import { onDownload } from '../../../Atoms/DataDisplay/DataGrid/helper/download.helper'
import { Skeleton } from '@material-ui/lab'

const M_TabsEmail = (props) => {
    const [email, setEmail] = useState(null)
    const [isDocumentDownloading, setIsDocumentDownloading] = useState(false);
    const [emailLoading, setEmailLoading] = useState(false);
    const handleDownloadDoc = async (fileName) => {
        setIsDocumentDownloading(true);
        await onDownload(fileName, "email")
        setIsDocumentDownloading(false);
    };
    useEffect(() => {
        let getEmailInfo = async () => {

            let localEmail = props.email;
            if (localEmail) {
                setEmailLoading(true)
                let uniqueEmails = {};
                let recipients = localEmail.recipients.trim().split(", ");
                let ccUsers = localEmail.ccUsers.trim().split(", ");
                if (ccUsers == "[]") {
                    ccUsers = [];
                }
                recipients.forEach((user) => {
                    uniqueEmails[user] = 1;
                })
                ccUsers.forEach((user) => {
                    uniqueEmails[user] = 1;
                })
                if (localEmail.sentBy !== "") {
                    uniqueEmails[localEmail.sentBy] = 1;
                }

                let emailsParam = JSON.stringify(Object.keys(uniqueEmails));
                let emailsWithNames = await getEmailAndNamesGremlinSP(emailsParam);
                let emailsWithNamesMap = {};
                emailsWithNames.forEach((element) => {
                    emailsWithNamesMap[element.email] = `${element.firstName} ${element.lastName}`
                })

                let recipientNames = recipients.map(user => emailsWithNamesMap[user] || null);
                let ccUserNames = ccUsers.map(user => emailsWithNamesMap[user]) || null;
                let sentByName = emailsWithNamesMap[localEmail.sentBy] || null;
                let documents = [];
                let mailDate = epochToDateFormatHelper(localEmail.createdDate, "DD/MM/YYYY HH:mm");
                if (localEmail.attachments !== "") {
                    documents = localEmail.attachments.split(",");
                    documents = documents.map((doc) => {
                        let docStringElements = doc.split('/');
                        docStringElements.shift();
                        return docStringElements.join("/") || null;
                    })
                }

                setEmail({ ...localEmail, recipients: recipientNames, ccUsers: ccUserNames, sentBy: sentByName, documents, mailDate })
                setEmailLoading(false)
            }
        }
        getEmailInfo()

    }, [props.email])

    if (emailLoading) {
        return <Skeleton variant="rect" width={210} height={120} />
    }

    return (
        <MailBox item={email} handleDownloadDoc={handleDownloadDoc} isDocumentDownloading={isDocumentDownloading} />
    )
}

M_TabsEmail.propTypes = {
    email: PropTypes.object
}


const MailBox = ({ item, handleDownloadDoc, isDocumentDownloading }) => {
    if (!item) {
        return <></>
    }
    let recipientsLength = item.recipients?.length;
    return (
        <div className="mail_tile">
            <div className="mail_prop">
                <span className="prop_key">From :</span>
                <div>
                    {
                        <span >{item.sentBy || "-"}</span>
                    }
                </div>
            </div>
            <div className="mail_prop">
                <span className="prop_key">To :</span>
                <div>
                    {
                        item.recipients?.map((recipient, index) => <> <span key={index}>{recipient}</span>{index != (item.recipients.length - 1) && <span>, </span>}</>)
                    }
                </div>
            </div>
            <div className="mail_prop">
                <span className="prop_key">CC :</span>
                <div>
                    {
                        item.ccUsers?.map((recipient, index) =>
                            <>
                                {recipient && <span key={index}>{recipient}</span>}
                                {index != (recipientsLength - 1) && <span>, </span>}
                            </>
                        )
                    }
                </div>
            </div>
            <div className="mail_prop">
                <span className="prop_key">Subject : </span>
                <span>{item.subject}</span>
            </div>
            <div className="mail_prop">
                <span className="prop_key" >Request :</span>
                <div dangerouslySetInnerHTML={{
                    __html: item.body ? item.body : "",
                }}
                />
            </div>
            <div>
                <span className="prop_key">Attachments</span>
                <Attachments item={item} handleDownloadDoc={handleDownloadDoc} isDocumentDownloading={isDocumentDownloading} />
            </div>
        </div>
    )
}

MailBox.propTypes = {
    item: PropTypes.object,
    handleDownloadDoc: PropTypes.func,
    isDocumentDownloading: PropTypes.bool
};

const Attachments = ({ item, isDocumentDownloading, handleDownloadDoc }) => {
    return (
        item.documents
            ? <>
                {
                    item.documents.map((doc) => {
                        return (
                            <div className="document_list" key={doc}>
                                <div className={`dot ${isDocumentDownloading ? "dotDisabled" : ""}`} />
                                <Typography >
                                    <button
                                        className={`document ${isDocumentDownloading ? "documentDisabled" : ""}`}
                                        disabled={isDocumentDownloading}
                                        onClick={() =>
                                            handleDownloadDoc(doc)
                                        }
                                    >
                                        {doc.split("/").pop()}
                                    </button>
                                </Typography>
                            </div>
                        );
                    })
                }
            </>
            : ""

    )
}

Attachments.propTypes = {
    item: PropTypes.object,
    handleDownloadDoc: PropTypes.func,
    isDocumentDownloading: PropTypes.bool
}

export default M_TabsEmail